module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/coming-soon/coming-soon.component.scss
// module id = ./src/app/shared/components/coming-soon/coming-soon.component.scss
// module chunks = main